import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SicotService } from '../../sicot.service';
import { TipoStruttura } from '../../types/TipoStruttura';
import { CommonModule } from '@angular/common';

export interface TipoStrutturaDialogData {
  /** Se presente = modifica, altrimenti = crea. */
  tipoStruttura?: TipoStruttura | null;
}

@Component({
  selector: 'app-tipo-struttura-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './tipo-struttura-dialog.component.html',
  styleUrl: './tipo-struttura-dialog.component.css',
})
export class TipoStrutturaDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly sicot = inject(SicotService);
  private readonly dialogRef = inject(MatDialogRef<TipoStrutturaDialogComponent>);
  private readonly data = inject<TipoStrutturaDialogData>(MAT_DIALOG_DATA);

  form: FormGroup;
  isEdit: boolean;
  submitting = false;
  errorMessage: string | null = null;

  constructor() {
    const t = this.data?.tipoStruttura;
    this.isEdit = t != null;
    this.form = this.fb.group({
      id: [{ value: t?.id ?? null, disabled: this.isEdit }, [Validators.required]],
      codice: [t?.codice ?? '', [Validators.required]],
      descrizione: [t?.descrizione ?? '', [Validators.required]],
    });
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.errorMessage = null;
    this.submitting = true;
    const raw = this.form.getRawValue();
    const id = raw.id as number;
    const codice = raw.codice as string;
    const descrizione = raw.descrizione as string;

    if (this.isEdit) {
      this.sicot.updateTipoStruttura(id, { codice, descrizione }).subscribe({
        next: (updated) => {
          this.dialogRef.close(updated);
        },
        error: (err) => {
          this.errorMessage = err?.error?.message ?? 'Errore durante l\'aggiornamento.';
          this.submitting = false;
        },
      });
    } else {
      this.sicot.createTipoStruttura({ id, codice, descrizione }).subscribe({
        next: (created) => {
          this.dialogRef.close(created);
        },
        error: (err) => {
          this.errorMessage = err?.status === 409
            ? 'Un tipo struttura con questo id esiste già.'
            : (err?.error?.message ?? 'Errore durante la creazione.');
          this.submitting = false;
        },
      });
    }
  }
}
